module.exports = __webpack_public_path__ + "static/media/UA.9a8f121d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/UA.svg
// module id = 2283
// module chunks = 7